import React, { useState, useEffect, useContext } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { MyContext } from "../MainContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faUserMinus } from '@fortawesome/free-solid-svg-icons';
import LoadingScreen from './loading_screen';
import { backendUrl } from '../utils/variables';


export default function FollowModal({ show, onHide, type, profileUserId }) {
    const { user } = useContext(MyContext);
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [processing, setProcessing] = useState({});

    const API_BASE = backendUrl;


    useEffect(() => {
        if (show && profileUserId) {
            fetchUsers();
        }
    }, [show, type, profileUserId]);

    const fetchUsers = async () => {
        if (!profileUserId) return;

        setLoading(true);
        const endpoint = type === 'followers' ? 'get_followers.php' : 'get_following.php';

        try {
            const response = await fetch(`${API_BASE}/${endpoint}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    profile_id: profileUserId,
                    viewer_id: user && user.user_id ? user.user_id : 0
                }),
            });

            const data = await response.json();
            if (data.success) {
                setUsers(type === 'followers' ? data.followers : data.following);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleFollow = async (targetUserId, currentStatus) => {
        if (processing[targetUserId] || !user || !user.user_id) return;

        setProcessing(prev => ({ ...prev, [targetUserId]: true }));

        try {
            const response = await fetch(`${API_BASE}/toggle_follow.php`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    profile_id: targetUserId,
                    my_id: user.user_id
                }),
            });

            const data = await response.json();
            if (data.success) {
                // Update the user's follow status in the list
                setUsers(prev => prev.map(u => 
                    u.id === targetUserId 
                        ? { ...u, is_following: data.follow ? 1 : 0 }
                        : u
                ));
            } else {
                alert(data.messages || 'Failed to update follow status');
            }
        } catch (error) {
            console.error('Error toggling follow:', error);
            alert('Network error. Please try again.');
        } finally {
            setProcessing(prev => ({ ...prev, [targetUserId]: false }));
        }
    };

    const handleUserClick = (username) => {
        onHide();
        navigate(`/${username}`);
    };

    return (
        <Modal show={show} onHide={onHide} centered size="md">
            <Modal.Header closeButton>
                <Modal.Title>{type === 'followers' ? 'Followers' : 'Following'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                {loading ? (
                    <div className="p-4 text-center">
                        <LoadingScreen />
                    </div>
                ) : users.length === 0 ? (
                    <div className="p-4 text-center text-muted">
                        No {type === 'followers' ? 'followers' : 'following'} yet
                    </div>
                ) : (
                    <div className="list-group list-group-flush">
                        {users.map((userItem) => (
                            <div
                                key={userItem.id}
                                className="list-group-item d-flex align-items-center"
                                style={{ cursor: 'pointer' }}
                            >
                                <img
                                    src={userItem.photo || `${process.env.PUBLIC_URL}/avatar.jpg`}
                                    alt={userItem.username}
                                    className="rounded-circle me-3"
                                    width="50"
                                    height="50"
                                    onClick={() => handleUserClick(userItem.username)}
                                />
                                <div 
                                    className="flex-grow-1"
                                    onClick={() => handleUserClick(userItem.username)}
                                >
                                    <h6 className="mb-0">
                                        {userItem.first_name} {userItem.last_name}
                                    </h6>
                                    <small className="text-muted">@{userItem.username}</small>
                                </div>
                                {user && user.user_id && user.user_id !== userItem.id && (
                                    <button
                                        className={`btn btn-sm ${userItem.is_following ? 'btn-outline-danger' : 'btn-primary'}`}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleToggleFollow(userItem.id, userItem.is_following);
                                        }}
                                        disabled={processing[userItem.id]}
                                    >
                                        <FontAwesomeIcon 
                                            icon={userItem.is_following ? faUserMinus : faUserPlus} 
                                            className="me-1" 
                                        />
                                        {processing[userItem.id] 
                                            ? '...' 
                                            : userItem.is_following 
                                                ? 'Unfollow' 
                                                : 'Follow'}
                                    </button>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

